import { render } from "./eventRegistration.vue?vue&type=template&id=a12bea6c&scoped=true"
import script from "./eventRegistration.vue?vue&type=script&lang=js"
export * from "./eventRegistration.vue?vue&type=script&lang=js"

import "./eventRegistration.vue?vue&type=style&index=0&id=a12bea6c&lang=scss&scoped=true"
import "./eventRegistration.vue?vue&type=style&index=1&id=a12bea6c&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12bea6c"]])

export default __exports__